import { IGetFolhaPagamentoUseCase } from "../../../presentation/useCases/read/get_folha_pagamento_use_case";
import { FolhaPagamento } from "../../models/folha_pagamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFolhaPagamentoUseCase
 */

export class GetFolhaPagamentoUseCase implements IGetFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFolhaPagamento(
    idFolhaPagamento: number,
  ): Promise<FolhaPagamento | null> {
    return await this.repository.getFolhaPagamento(idFolhaPagamento);
  }
}
